module.exports = __webpack_public_path__ + "static/media/grimberg-damian.ae53affd.jpg";